import { useMutation } from '@tanstack/react-query';
import { clearTransactions } from 'api/resources/transactions';
import { ECacheKeys } from 'cache/CacheKeys';

export const usePostClearTransactions = () => {
	return useMutation(({ id }: { id: number }) => clearTransactions(id), {
		mutationKey: [ECacheKeys.ClearTransactions],
	});
};
